<template>

<com-item name="game.affinity.exploration" :size="size" :loading="loading" :is-empty="!active" :has-more="hasMore" v-on:more="onMore" title="Exploration">

	<template v-slot:about>

		<p>How deep {{ you }}'ve gone into this game's attributes.</p>

	</template>

	<template v-slot:stats>

		<div class="exploration" v-if="active">

			<div class="exploration-row" v-for="(item, index) in items" :key="index" v-on:click="onSelect(item)" v-tooltip="'View ' + item.name + ' games'">

				<div class="exploration-row-head">

					<div class="exploration-row-name">{{ item.name }}<span class="exploration-row-type" v-if="hasMultipleTypes">{{ item.type }}</span></div>

					<div class="exploration-row-count">{{ item.tried }}<span class="exploration-row-total"> / {{ item.total }}</span></div>

				</div>

				<div class="exploration-row-bar">

					<div class="exploration-row-bar-fill" :style="{ width: item.percent + '%' }" />

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/affinity'] },

		items: function() {

			return (this.data && this.data.exploration) ? this.data.exploration : []

		},

		total: function() {

			return (this.data && this.data.explorationTotal) ? this.data.explorationTotal : 0

		},

		hasMore: function() { return this.total > 5 },

		active: function() { return !this.loading && this.items.length },

		hasMultipleTypes: function() {

			if (this.items.length < 2) return false

			var first = this.items[0].type

			for (var i = 1; i < this.items.length; i++) {

				if (this.items[i].type !== first) return true

			}

			return false

		}

	},

	methods: {

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityExploration',
				id: parseInt(this.$route.params.game) || 0
			})

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: parseInt(this.$route.params.game) || 0,
				attrType: item.type,
				attrId: item.id
			})

		}

	}

}

</script>

<style scoped>

.exploration {
	width: 100%;
}

.exploration-row {
	min-height: 64px;
	padding: 8px 15px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.exploration-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.exploration-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.exploration-row-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 6px;
}

.exploration-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.exploration-row-type {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-left: 6px;
}

.exploration-row-count {
	font-size: 18px;
	font-weight: 700;
	color: #4881bb;
	flex-shrink: 0;
	margin-left: 10px;
}

.exploration-row-total {
	font-size: 12px;
	font-weight: 400;
	color: #999;
}

.exploration-row-bar {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 2px;
	position: relative;
}

.exploration-row-bar-fill {
	height: 100%;
	background-color: #4881bb;
	border-radius: 2px;
}

</style>
